import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './App.css';
import AppRouter from './AppRouter';
import { ConfigProvider } from 'antd';
import { ANT_DESIGN_THEME } from './constants';

declare global {
  interface Array<T> {
    sumArray: (arr: T[]) => T[];
  }
}

// eslint-disable-next-line no-extend-native
Array.prototype.sumArray = function (arr: any[]) {
  var sum = [];
  if (arr != null && this.length === arr.length) {
    for (var i = 0; i < arr.length; i++) {
      sum.push(this[i] + arr[i]);
    }
  }
  return sum;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <Helmet>
          <title>Review Circle</title>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Commissioner" />
          <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
        </Helmet>

        <ConfigProvider theme={ANT_DESIGN_THEME}>
          <AppRouter />
        </ConfigProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
